import { DISTRICTS_CANON } from '../constants/canonicalEnums';

export const REGION_LABELS = { istanbul_geneli: 'İstanbul geneli', avrupa_yakasi: 'Avrupa Yakası', anadolu_yakasi: 'Anadolu Yakası' };
const normalize = value => String(value).trim().normalize('NFC').replace(/^Kâğıthane$/, 'Kağıthane');
const anatolian = ['Adalar', 'Ataşehir', 'Beykoz', 'Çekmeköy', 'Kadıköy', 'Kartal', 'Maltepe', 'Pendik', 'Sancaktepe', 'Sultanbeyli', 'Şile', 'Tuzla', 'Ümraniye', 'Üsküdar'];
const districts = DISTRICTS_CANON.map(normalize);
const regions = { istanbul_geneli: districts, avrupa_yakasi: districts.filter(d => !anatolian.includes(d)), anadolu_yakasi: anatolian };

// Compress only complete regions. A partial selection keeps its exact district names.
export const districtSummary = values => {
  const remaining = new Set();
  for (const value of Array.isArray(values) ? values : values == null ? [] : [values]) {
    if (value == null || !String(value).trim()) continue;
    const name = normalize(value);
    for (const district of regions[name] || [name]) remaining.add(district);
  }
  const summary = [];
  for (const [key, members] of Object.entries(regions)) {
    if (members.every(d => remaining.has(d))) {
      summary.push(REGION_LABELS[key]);
      members.forEach(d => remaining.delete(d));
    }
  }
  return [...summary, ...remaining].join(', ');
};
